// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qv-0";